export const DARK_GREY = "#252525";
export const LESS_DARK_GREY = "#2c2c2c";
export const MEDIUM_GREY = "#454545";
export const LIGHT_GREY = "#8d8d8d";
export const LIGHT_BLUE = "#70927b";
export const DARK_YELLOW = "#96885f";
export const WHITE = "#e1e1e1";
